/**
 * China Chat component
 */
(function () {
    'use strict';

    var itxUrlChatCmp = {
        controller: itxUrlChatCmpCtrl,
        templateUrl: 'url-chat.component.html',
        bindings: {
            config: '<'
        }
    };

    itxUrlChatCmpCtrl.$inject = ['ItxUrlChatSvc', 'ItxStaticResourceSvc', '$rootScope', '$timeout'];

    function itxUrlChatCmpCtrl(ItxUrlChatSvc, ItxStaticResourceSvc, $rootScope, $timeout) {
        var _this = this;

        // Inicialización de la configuración
        _this.urlChatConfiguration = {
            isLoading: true,
            icon: ItxStaticResourceSvc.getIcon('chat2.svg')
        };

        _this.$onInit = function () {
            ItxUrlChatSvc.initWidget(_this.config);

            setTimeout(function () {
                document.getElementById('imbee-app-iframe').addEventListener('load', function () {
                    $timeout(function () {
                        _this.urlChatConfiguration.isLoading = false;
                    });
                });
            }, 1000);
        };

        /**
         * Función para cerrar el chat
         */
        _this.close = function () {
            $('.url-chat').removeClass('open');

            $rootScope.$broadcast('changeChatVisualizations', {
                event: 'showButton'
            });
        };
    }

    angular.module('itxApp.common').component('itxUrlChat', itxUrlChatCmp);
})();
